module.exports = __webpack_public_path__ + "img/pin-double-diamond.a89bac62.png";